import { stringify } from 'qs';
import request from '@/utils/request';

export async function refreshLicense(companyCode) {
    return request(`/iwms-account/account/license?companyCode=${companyCode}`);
}

export async function queryLicense() {
    return request(`/iwms-account/account/list/license`);
}

export async function uploadLicense(payload) {
    return request(`/iwms-account/account/uploadLicense?companyCode=${payload.companyCode}`, {
        method: 'POST',
        body: payload.body,
    });
}

export async function getConfig() {
    return request(`/iwms-account/account/licenseconfig/get`);
}

export async function saveConfig(payload) {
    return request(`/iwms-account/account/licenseconfig/save`, {
        method: 'POST',
        body: payload.body,
    });
}
